import RegisterService from '../services/register.service';

export const register = {
    namespaced: true,
    state: {
        message: null
    },
    actions: {
        register({ commit }, user) {
            return RegisterService.createPrestataire(user)
                .then(response => {
                    commit('registerSuccess');
                    return response;
                })
            .catch(error => {
                commit('registerFailure');

                if (error.response && error.response.data) {

                    if (error.response.data.messages) {
                        return Promise.reject(error.response.data.messages);
                    }

                    if (error.response.data.errors) {
                        return Promise.reject(error.response.data.errors);
                    }

                    if (error.response.data.error) {
                        return Promise.reject({
                            general: [error.response.data.error]
                        });
                    }
                }

                return Promise.reject({
                    general: ["Une erreur est survenue"]
                });
            });
        },


    registerR({ commit }, user) {
        return RegisterService.createRecruteur(user)
            .then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response);
                })
        .then(response => {
                    commit('registerSuccess');
                    return response;
                })
            .catch(error => {
                commit('registerFailure');

                if (error.response && error.response.data) {

                    if (error.response.data.messages) {
                        return Promise.reject(error.response.data.messages);
                    }

                    if (error.response.data.errors) {
                        return Promise.reject(error.response.data.errors);
                    }

                    if (error.response.data.error) {
                        return Promise.reject({
                            general: [error.response.data.error]
                        });
                    }
                }

                return Promise.reject({
                    general: ["Une erreur est survenue"]
                });
            });
    },
},

    
    mutations: {
        registerSuccess(state) {
            state.message = "Ok";
        },
        registerFailure(state) {
            state.message = null;
        }
    }
};